module.exports = (window._g && _g.$) || window.$CQ || window.$ || window.jQuery;


//////////////////
// WEBPACK FOOTER
// external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
// module id = 0
// module chunks = 0